import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { MachineDoc } from '@models';

@Injectable({ providedIn: 'root' })
export class MachineDocService extends CrudService<MachineDoc> {
  constructor() {
    super('machine-docs', MachineDoc);
  }
}

